export default __webpack_public_path__ + "static/act-2b26c1af3cf1ba3a2184b534093eafdd.png";